import { render, staticRenderFns } from "./additionalInformation.vue?vue&type=template&id=f8f45e6e&scoped=true&"
import script from "./additionalInformation.vue?vue&type=script&lang=js&"
export * from "./additionalInformation.vue?vue&type=script&lang=js&"
import style0 from "./additionalInformation.vue?vue&type=style&index=0&id=f8f45e6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f45e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f8f45e6e', component.options)
    } else {
      api.reload('f8f45e6e', component.options)
    }
    module.hot.accept("./additionalInformation.vue?vue&type=template&id=f8f45e6e&scoped=true&", function () {
      api.rerender('f8f45e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/additionalInformation.vue"
export default component.exports